import { FC } from 'react'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import ContentLoader from '@shared/lib/components/SkeletonContentLoader'
import { SKELETON_FOREGROUND_COLOR, SKELETON_MAIN_COLOR, SKELETON_SPEED } from '@shared/consts/skeleton'
import s from '@shared/ui/Layout/Cards/MainCard/MainCard.module.sass'
import { useCurrentSize } from '@shared/lib/helpers/classes'

interface Props {
  sizes?: string
  classNameWrapper?: string
  layout?: 'default' | 'feature'
}

const Skeleton: FC<Props> = ({ sizes = 'XL S', classNameWrapper = '', layout = 'default' }) => {
  const [size] = useCurrentSize(sizes)

  return (
    <BlockBoundary>
      <ContentLoader
        speed={SKELETON_SPEED}
        backgroundColor={SKELETON_MAIN_COLOR}
        foregroundColor={SKELETON_FOREGROUND_COLOR}
        className={`${s.card} ${classNameWrapper}`}
        data-cover-size={size}
        data-layout={layout}>
        <rect x='0' y='0' rx='32' ry='32' width={'100%'} height={'100%'} />
      </ContentLoader>
    </BlockBoundary>
  )
}

export default Skeleton
